// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row-tarjeta.row.fadeOut {
  animation: fadeOut 1s;
}

.pagos-info-tarjeta {
  align-items: center;
  display: flex;
  margin-bottom: 2em;
}

.pagos-default {
  width: 17%;
}

.pagos-datos {
  border: 2px solid #2b363b;
  border-radius: 16px;
  padding: 0.9em 1.3em;
  width: 66%;
}

.pagos-remove {
  text-align: right;
  width: 17%;
}

.pagos-remove-icon {
  width: 24px;
  height: 24px;
}

.pagos-datos span {
  display: block;
}

.pagos-caducidad {
  font-size: 0.9em;
  color: #555;
}

.pagos-datos span:first-child {
  font-size: 1.1em;
  font-weight: 700;
  margin-bottom: 0.2em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pagos-datos span:last-child {
  text-transform: uppercase;
}

.pagos-default .input-group-text {
  border: none;
}

.pagos-remove button:focus,
.pagos-remove button:active:focus {
  box-shadow: none;
}

.pagos-default input[type="radio"]:checked:after {
  content: "\\2714" !important;
  font-size: 1em;
  line-height: 1.3em;
}

.pagos-btn {
  background-color: #fff;
  bottom: 0;
  padding: 2% 0 4% 0;
  position: sticky;
  width: 94vw;
}

.pagos-btn-nueva {
  width: 100%;
}

.pagos-estado-img {
  margin: 0 auto;
  width: 18vw;
}

.pagos-estado-text,
.pagos-estado-info,
.pagos-estado-info-adicional {
  text-align: center;
}
.pagos-estado-text {
  font-size: 4.8vw;
  font-weight: 700;
}

.pagos-estado-info {
  font-size: 0.9em;
  font-weight: 800;
}

.pagos-estado-info-adicional {
  font-size: 0.8em;
  font-weight: 400;
}

.pagos-remove > button.user-config > img:hover {
  filter: invert(8%) sepia(13%) saturate(7%) hue-rotate(295deg) brightness(95%)
    contrast(320%);
}

table.historial-pagos span.input-group-text {
  border: none;
}

table.historial-pagos > :not(:first-child) {
  border-top: none;
}

table.historial-pagos tr {
  border-bottom: 1px solid rgba(230, 233, 241, 0.8);
}

table.historial-pagos td {
  padding-bottom: 1.7em;
  padding-top: 1.7em;
  vertical-align: middle;
}

table.historial-pagos th,
table.historial-pagos td {
  padding-right: 11vw;
  white-space: nowrap;
}

table.historial-pagos td.historial-nombre,
table.historial-pagos td.historial-tarjeta,
table.historial-pagos td.historial-marca {
  text-transform: uppercase;
}

.historial-fecha {
  color: #3d3d3d;
  font-weight: 600 !important;
}

span.historial-fecha-hora {
  display: block;
  font-weight: 400;
  font-size: 0.9em;
}

/* BREAKPOINT TABLETS*/
@media (min-width: 768px) {
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  .pagos-default {
    width: 15%;
  }

  .pagos-default input[type="radio"]:checked:after {
    line-height: 1.2em;
  }

  .pagos-btn-nueva {
    font-size: 1em;
    width: -moz-fit-content;
    width: fit-content;
  }

  .pagos-estado-img {
    margin: 0 auto;
    max-width: 100px;
  }

  .pagos-estado-text,
  .pagos-estado-info,
  .pagos-estado-info-adicional {
    max-width: 50%;
    margin: 0 auto;
    display: block;
  }

  .pagos-estado-text {
    font-size: 1.7em;
  }

  .pagos-estado-info {
    font-size: 0.9em;
    font-weight: 800;
  }

  .pagos-estado-info-adicional {
    font-size: 0.8em;
    font-weight: 400;
  }

  table.historial-pagos th,
  table.historial-pagos td {
    padding-right: 1.5em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pago/metodospago.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;kBACgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;AACA;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;;IAGE,cAAc;IACd,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;IAEE,oBAAoB;EACtB;AACF","sourcesContent":[".row-tarjeta.row.fadeOut {\r\n  animation: fadeOut 1s;\r\n}\r\n\r\n.pagos-info-tarjeta {\r\n  align-items: center;\r\n  display: flex;\r\n  margin-bottom: 2em;\r\n}\r\n\r\n.pagos-default {\r\n  width: 17%;\r\n}\r\n\r\n.pagos-datos {\r\n  border: 2px solid #2b363b;\r\n  border-radius: 16px;\r\n  padding: 0.9em 1.3em;\r\n  width: 66%;\r\n}\r\n\r\n.pagos-remove {\r\n  text-align: right;\r\n  width: 17%;\r\n}\r\n\r\n.pagos-remove-icon {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.pagos-datos span {\r\n  display: block;\r\n}\r\n\r\n.pagos-caducidad {\r\n  font-size: 0.9em;\r\n  color: #555;\r\n}\r\n\r\n.pagos-datos span:first-child {\r\n  font-size: 1.1em;\r\n  font-weight: 700;\r\n  margin-bottom: 0.2em;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.pagos-datos span:last-child {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.pagos-default .input-group-text {\r\n  border: none;\r\n}\r\n\r\n.pagos-remove button:focus,\r\n.pagos-remove button:active:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.pagos-default input[type=\"radio\"]:checked:after {\r\n  content: \"\\2714\" !important;\r\n  font-size: 1em;\r\n  line-height: 1.3em;\r\n}\r\n\r\n.pagos-btn {\r\n  background-color: #fff;\r\n  bottom: 0;\r\n  padding: 2% 0 4% 0;\r\n  position: sticky;\r\n  width: 94vw;\r\n}\r\n\r\n.pagos-btn-nueva {\r\n  width: 100%;\r\n}\r\n\r\n.pagos-estado-img {\r\n  margin: 0 auto;\r\n  width: 18vw;\r\n}\r\n\r\n.pagos-estado-text,\r\n.pagos-estado-info,\r\n.pagos-estado-info-adicional {\r\n  text-align: center;\r\n}\r\n.pagos-estado-text {\r\n  font-size: 4.8vw;\r\n  font-weight: 700;\r\n}\r\n\r\n.pagos-estado-info {\r\n  font-size: 0.9em;\r\n  font-weight: 800;\r\n}\r\n\r\n.pagos-estado-info-adicional {\r\n  font-size: 0.8em;\r\n  font-weight: 400;\r\n}\r\n\r\n.pagos-remove > button.user-config > img:hover {\r\n  filter: invert(8%) sepia(13%) saturate(7%) hue-rotate(295deg) brightness(95%)\r\n    contrast(320%);\r\n}\r\n\r\ntable.historial-pagos span.input-group-text {\r\n  border: none;\r\n}\r\n\r\ntable.historial-pagos > :not(:first-child) {\r\n  border-top: none;\r\n}\r\n\r\ntable.historial-pagos tr {\r\n  border-bottom: 1px solid rgba(230, 233, 241, 0.8);\r\n}\r\n\r\ntable.historial-pagos td {\r\n  padding-bottom: 1.7em;\r\n  padding-top: 1.7em;\r\n  vertical-align: middle;\r\n}\r\n\r\ntable.historial-pagos th,\r\ntable.historial-pagos td {\r\n  padding-right: 11vw;\r\n  white-space: nowrap;\r\n}\r\n\r\ntable.historial-pagos td.historial-nombre,\r\ntable.historial-pagos td.historial-tarjeta,\r\ntable.historial-pagos td.historial-marca {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.historial-fecha {\r\n  color: #3d3d3d;\r\n  font-weight: 600 !important;\r\n}\r\n\r\nspan.historial-fecha-hora {\r\n  display: block;\r\n  font-weight: 400;\r\n  font-size: 0.9em;\r\n}\r\n\r\n/* BREAKPOINT TABLETS*/\r\n@media (min-width: 768px) {\r\n}\r\n\r\n/* BREAKPOINT ESCRITORIO */\r\n@media (min-width: 992px) {\r\n  .pagos-default {\r\n    width: 15%;\r\n  }\r\n\r\n  .pagos-default input[type=\"radio\"]:checked:after {\r\n    line-height: 1.2em;\r\n  }\r\n\r\n  .pagos-btn-nueva {\r\n    font-size: 1em;\r\n    width: fit-content;\r\n  }\r\n\r\n  .pagos-estado-img {\r\n    margin: 0 auto;\r\n    max-width: 100px;\r\n  }\r\n\r\n  .pagos-estado-text,\r\n  .pagos-estado-info,\r\n  .pagos-estado-info-adicional {\r\n    max-width: 50%;\r\n    margin: 0 auto;\r\n    display: block;\r\n  }\r\n\r\n  .pagos-estado-text {\r\n    font-size: 1.7em;\r\n  }\r\n\r\n  .pagos-estado-info {\r\n    font-size: 0.9em;\r\n    font-weight: 800;\r\n  }\r\n\r\n  .pagos-estado-info-adicional {\r\n    font-size: 0.8em;\r\n    font-weight: 400;\r\n  }\r\n\r\n  table.historial-pagos th,\r\n  table.historial-pagos td {\r\n    padding-right: 1.5em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
